import { bostonConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function BostonPage() {
  return <CityPageTemplate config={bostonConfig} />;
}